import { useAaroQuery } from './useAaroQuery';
import { getContracts, getCustomerMovements, getProductMovements } from 'services/outside/aaro/aaroDekont';

export function useContractQueries(contractId, options = {}) {
    const contractQuery = useAaroQuery({
        queryKey: ['contract', contractId],
        queryFn: () => getContracts({ SozlesmeID: contractId }),
        options: {
            ...options,
            requireSuccess: true,
            enabled: Boolean(contractId),
        },
    });

    const movementsQuery = useAaroQuery({
        queryKey: ['customerMovements', contractId],
        queryFn: () => getCustomerMovements({ SozlesmeID: contractId, SayfaSatirSayisi: 100 }),
        options: {
            ...options,
            requireSuccess: true,
            enabled: Boolean(contractId),
        },
    });

    const productMovementsQuery = useAaroQuery({
        queryKey: ['productMovements', contractId],
        queryFn: () => getProductMovements({ SozlesmeID: contractId, SayfaSatirSayisi: 100 }),
        options: {
            ...options,
            requireSuccess: true,
            enabled: Boolean(contractId),
        },
    });

    return {
        contractQuery,
        movementsQuery,
        productMovementsQuery,
    };
}
